import { FC, Link, stringifyQueryString as query } from 'external/react'
import Icon from 'external/fortawesome'
import { Course } from '../../types/course'
import { clsx } from 'external/clsx'

type PackageEditCourseProps = {
    course: Course,
    extra: boolean
}

const PackageEditCourse : FC<PackageEditCourseProps> = props => {
    const {offerId, subjectId, cartIndex, type, language } = props.course
    const to = {pathname: `/courses/${subjectId}/${offerId}/${cartIndex}/${type}`, search: query({languageId: language, fromCart: true, extra: props.extra})} 
    return (
       <Link style={{ padding: '8px', borderRadius: '100%', background: '#ececec', cursor: 'pointer'}} to={to}>
            <Icon name='faPenToSquare' color='#1797D0' className='px-1' title='editar' />
        </Link>
    )
}

export const PackageSelectComplementaryCourse : FC<PackageEditCourseProps> = props => {
    const {offerId, subjectId, cartIndex, type, language } = props.course
    const to = {pathname: `/courses/${subjectId}/${offerId}/${cartIndex}/${type}`, search: query({languageId: language, fromCart: true, extra: true})} 
    return (
		<Link to={to} className='d-flex text-decoration-none mt-2'>
			<div className='d-flex flex-column justify-content-center' style={{ width: '90px', height: '113px', borderRadius: '10px', "border": "outset 1px #cacacaff" }} >
				<Icon name='faCirclePlus' color='#1797D0' className='plus-rounded-active fa-2x' />
			</div>
		</Link>
    )
}

export {PackageEditCourse as default}